export const METRICS = {
  recovery: {
    label: "Восстановление", unit: "%", color: "#00e676", higher: "better", domain: [0, 100],
    desc: "Главный показатель готовности организма к нагрузке. Whoop рассчитывает его каждое утро на основе HRV, пульса покоя, качества сна и частоты дыхания. 67–100% — зелёная зона (можно выкладываться), 34–66% — жёлтая (умеренная нагрузка), 0–33% — красная (нужен отдых).",
  },
  strain: {
    label: "Дневная нагрузка", unit: "из 21", color: "#0084ff", higher: "neutral", domain: [0, 21],
    desc: "Кардионагрузка за день по логарифмической шкале от 0 до 21. Учитывает время в пульсовых зонах: чем выше пульс и дольше нагрузка, тем выше показатель. Оптимальный диапазон зависит от текущего восстановления — смотрите «Цель по нагрузке».",
  },
  sleep_performance: {
    label: "Эффективность сна", unit: "%", color: "#a970ff", higher: "better", domain: [0, 100],
    desc: "Сколько сна вы получили относительно потребности организма (базовая норма + долг сна + компенсация нагрузки). 85%+ — отлично, ниже 70% — накапливается долг сна.",
  },
  sleep_h: {
    label: "Длительность сна", unit: "ч", color: "#a970ff", higher: "better",
    desc: "Чистое время сна без учёта бодрствования в постели. Большинству взрослых нужно 7–9 часов; вашу персональную потребность Whoop рассчитывает в «Сон сегодня».",
  },
  sleep_consistency: {
    label: "Стабильность сна", unit: "%", color: "#ffea00", higher: "better", domain: [0, 100],
    desc: "Насколько стабильно вы ложитесь и встаёте в одно и то же время. Стабильный циркадный ритм улучшает качество сна и восстановление сильнее, чем дополнительный час сна.",
  },
  sleep_efficiency: {
    label: "Качество сна", unit: "%", color: "#00e676", higher: "better", domain: [0, 100],
    desc: "Процент времени в постели, проведённый во сне. 90%+ — отличный показатель; низкие значения говорят о частых пробуждениях.",
  },
  hrv: {
    label: "HRV", unit: "мс", color: "#0084ff", higher: "better",
    desc: "Вариабельность сердечного ритма — главный маркер восстановления нервной системы. Измеряется в глубоком сне. Сравнивать имеет смысл только с вашей собственной базой: рост относительно неё — хорошо, падение — сигнал стресса, недосыпа или болезни.",
  },
  rhr: {
    label: "Пульс покоя", unit: "уд/мин", color: "#ff3b30", higher: "lower",
    desc: "Частота сердцебиения в самой глубокой фазе сна. Снижение с ростом тренированности — хорошо. Резкий рост выше вашей нормы — ранний признак усталости, обезвоживания или начинающейся болезни.",
  },
  spo2: {
    label: "SpO₂", unit: "%", color: "#4dabf5", higher: "better", domain: [88, 100],
    desc: "Насыщение крови кислородом во сне. Норма 95–100%. Устойчивые значения ниже 94% — повод обратить внимание на дыхание во сне и самочувствие.",
  },
  skin_temp: {
    label: "Температура кожи", unit: "°C", color: "#ff9100", higher: "neutral",
    desc: "Температура кожи во сне. Важно не абсолютное значение, а отклонение от вашей базы: рост на 0.5–1°C и больше часто предшествует болезни за 1–2 дня до симптомов.",
  },
  resp_rate: {
    label: "Частота дыхания", unit: "вд/мин", color: "#a970ff", higher: "neutral",
    desc: "Число вдохов в минуту во сне. Один из самых стабильных показателей организма — в норме почти не меняется. Рост на 1+ вдох относительно базы — один из самых ранних маркеров заболевания.",
  },
  kcal: {
    label: "Калории", unit: "ккал", color: "#ffea00", higher: "neutral",
    desc: "Суммарные затраты энергии за день (базовый обмен + активность), рассчитанные по пульсу.",
  },
};

export function metricStats(days, key) {
  const vals = days.map((d) => d[key]).filter((v) => v != null);
  if (!vals.length) return null;
  const cur = vals[vals.length - 1];
  const base = vals.length > 1 ? vals.slice(0, -1) : vals;
  const mean = base.reduce((a, b) => a + b, 0) / base.length;
  const sd = Math.sqrt(base.reduce((a, b) => a + (b - mean) ** 2, 0) / base.length) || Math.abs(mean) * 0.03 || 1;
  return {
    current: cur, avg: mean, min: Math.min(...vals), max: Math.max(...vals),
    lo: mean - 2 * sd, hi: mean + 2 * sd,
    deltaPct: mean ? ((cur - mean) / Math.abs(mean)) * 100 : 0,
    count: vals.length,
  };
}

export function metricVerdict(key, stats) {
  if (!stats || stats.count < 4) return { level: "info", text: "Пока мало данных для сравнения с вашей базой — носите трекер регулярно." };
  const m = METRICS[key];
  const { current, lo, hi, avg } = stats;
  if (key === "strain" || key === "kcal") {
    const diff = avg ? ((current - avg) / Math.abs(avg)) * 100 : 0;
    return { level: "info", text: `Нагрузка естественно меняется день ото дня — отклонения здесь не тревожный сигнал. Сегодня ${diff >= 0 ? "выше" : "ниже"} вашей средней (${avg.toFixed(1)} ${m.unit}) на ${Math.abs(diff).toFixed(0)}%. Ориентируйтесь на «Цель по нагрузке».` };
  }
  const dir = current > hi ? "high" : current < lo ? "low" : "norm";
  if (dir === "norm") return { level: "success", text: `Показатель в пределах вашей личной нормы (${lo.toFixed(1)}–${hi.toFixed(1)} ${m.unit}). Отклонение от средней базы ${avg.toFixed(1)} несущественно.` };
  const above = dir === "high";
  if (m.higher === "better") return above
    ? { level: "success", text: `Выше вашей нормы — отличный знак! Текущее значение заметно превосходит базу ${avg.toFixed(1)} ${m.unit}.` }
    : { level: "alert", text: `Ниже вашей нормы (база ${avg.toFixed(1)} ${m.unit}). Обратите внимание на сон, стресс и нагрузку в последние дни.` };
  if (m.higher === "lower") return above
    ? { level: "alert", text: `Выше вашей нормы (база ${avg.toFixed(1)} ${m.unit}) — организм может быть под нагрузкой: усталость, обезвоживание или болезнь.` }
    : { level: "success", text: `Ниже вашей нормы — хороший знак: организм восстанавливается лучше обычного (база ${avg.toFixed(1)} ${m.unit}).` };
  return { level: "warning", text: `Заметное отклонение от вашей базы ${avg.toFixed(1)} ${m.unit}. Для этого показателя важна стабильность — понаблюдайте пару дней.` };
}

export function trendGood(key, deltaPct) {
  const m = METRICS[key];
  if (!m || Math.abs(deltaPct) < 3) return "neutral";
  if (m.higher === "better") return deltaPct > 0 ? "good" : "bad";
  if (m.higher === "lower") return deltaPct > 0 ? "bad" : "good";
  return "neutral";
}

const AGG_KEYS = ["recovery", "hrv", "rhr", "strain", "kcal", "sleep_h", "deep_h", "rem_h", "light_h", "awake_h",
  "sleep_performance", "sleep_consistency", "sleep_efficiency", "resp_rate", "spo2", "skin_temp"];

export function aggregateMonthly(days) {
  const map = {};
  days.forEach((d) => {
    const m = d.date.slice(0, 7);
    if (!map[m]) map[m] = { date: m, _sum: {}, _n: {} };
    AGG_KEYS.forEach((k) => {
      if (d[k] != null) {
        map[m]._sum[k] = (map[m]._sum[k] || 0) + d[k];
        map[m]._n[k] = (map[m]._n[k] || 0) + 1;
      }
    });
  });
  return Object.values(map)
    .sort((a, b) => a.date.localeCompare(b.date))
    .map((r) => {
      const out = { date: r.date };
      AGG_KEYS.forEach((k) => {
        if (r._n[k]) out[k] = Math.round((r._sum[k] / r._n[k]) * 10) / 10;
      });
      return out;
    });
}
